import React from "react";
import {Button} from "react-bootstrap";
import "tippy.js/dist/tippy.css";
import Tooltip from "../tooltip/Tooltip";

const IconButton = ({variant, icon, className, show = true, tooltip, size, onClick, disabled, fullIcon, text}) => {

    return (
        <>
            {show &&
                <Tooltip tooltip={tooltip}>
                    <Button variant={variant}
                            size={size ? size : "md"}
                            disabled={disabled}
                            className={className + " icon-button"}
                            role="button"
                            onClick={onClick}>
                        <i className={fullIcon || ("fas " + icon)}/>
                        {text}
                    </Button>
                </Tooltip>
            }
        </>
    );
};


export default IconButton;